import { render, staticRenderFns } from "./B2BDetailPurchaseChange.vue?vue&type=template&id=65ca1ffb&scoped=true"
import script from "./B2BDetailPurchaseChange.vue?vue&type=script&lang=js"
export * from "./B2BDetailPurchaseChange.vue?vue&type=script&lang=js"
import style0 from "./B2BDetailPurchaseChange.vue?vue&type=style&index=0&id=65ca1ffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca1ffb",
  null
  
)

export default component.exports